import { render } from "./CruImported.vue?vue&type=template&id=4822e06e&scoped=true"
import script from "./CruImported.vue?vue&type=script&lang=js"
export * from "./CruImported.vue?vue&type=script&lang=js"

import "./CruImported.vue?vue&type=style&index=0&id=4822e06e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4822e06e"]])

export default __exports__